import { Progress, type ProgressRootProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ProgressRootProps {
  isIndeterminate?: boolean
}

export default forwardRef<HTMLDivElement, Props>(({ isIndeterminate, value, ...rest }, ref) => {
  return (
    <Progress.Root value={isIndeterminate ? null : value} {...rest} ref={ref}>
      <Progress.Track>
        <Progress.Range />
      </Progress.Track>
      <Progress.Label />
      <Progress.ValueText />
    </Progress.Root>
  )
})
